
import React from "react";
import { SEO } from "gatsby-theme-apollo-core";
import { withPrefix } from "gatsby";

export default function CustomSEO({ image, baseUrl, ...props }) {
  return (
    <SEO {...props} favicon={withPrefix("/favicon.ico")} twitterCard="summary_large_image">
      {baseUrl}
    </SEO>
  );
}
